<template>
  <b-card>
    <b-list-group>
      <b-list-group-item
        v-for="row in rows"
        :key="row.label"
      >
        <div class="text-primary font-weight-bold">
          {{ row.label }}
        </div>
        <div style="white-space: pre-line">
          {{ row.value || '-' }}
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div class="text-primary font-weight-bold">
          Özgeçmiş (CV)
        </div>
        <div class="mt-50">
          <b-button
            v-if="itemData.filename"
            variant="success"
            size="sm"
            :href="baseURL + '/media/hr_forms/' + itemData.filename"
            target="_blank"
          >
            <FeatherIcon icon="DownloadIcon" />
            Dosyayı Aç
          </b-button>
          <span v-else>-</span>
        </div>
      </b-list-group-item>
    </b-list-group>
    <b-button
      variant="outline-primary"
      class="mt-2"
      to="/app/hr-forms"
    >
      <FeatherIcon icon="ArrowLeftIcon" />
      Listeye Dön
    </b-button>
  </b-card>
</template>

<script>
import {
  BCard, BListGroup, BListGroupItem, BButton,
} from 'bootstrap-vue'

export default {
  name: 'HrFormsView',
  components: {
    BCard, BListGroup, BListGroupItem, BButton,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['hrForms/dataItem']
    },
    rows() {
      const d = this.itemData
      return [
        { label: 'Adı Soyadı', value: d.name },
        { label: 'E-Posta', value: d.email },
        { label: 'Telefon', value: d.phone },
        { label: 'Mesaj', value: d.content },
        { label: 'KVKK Onayı', value: Number(d.kvkk) ? 'Var' : 'Yok' },
        { label: 'Başvuru Tarihi', value: d.created ? this.moment(d.created).format('DD.MM.YYYY HH:mm') : null },
        { label: 'IP Adresi', value: d.ip_address },
      ]
    },
  },
  created() {
    this.$store.dispatch('hrForms/getDataItem', this.$route.params.id)
  },
}
</script>
